import { Link } from 'react-router-dom';
import { hotRanking } from '@/mocks/comics';

export default function HotRanking() {
  const top3 = hotRanking.slice(0, 3);
  const rest = hotRanking.slice(3, 10);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              热门排行
            </h2>
          </div>
          <Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-6">
          {top3.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group relative bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 flex"
            >
              <div className={`absolute top-0 left-0 w-8 h-8 flex items-center justify-center rounded-br-lg z-10 ${
                idx === 0 ? 'bg-primary-500' : idx === 1 ? 'bg-accent-500' : 'bg-secondary-500'
              } text-white font-bold text-sm`}>
                {idx + 1}
              </div>
              <div className="w-24 md:w-28 shrink-0">
                <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-3 md:p-4 flex flex-col justify-center min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-star-fill text-xs"></i> {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {comic.popularity > 1000000 ? `${(comic.popularity / 10000).toFixed(0)}万人气` : `${(comic.popularity / 10000).toFixed(1)}万人气`}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.latestChapter}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {rest.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-3 bg-background-50 rounded-lg border border-background-200/70 px-3 py-2.5 hover:border-primary-200 transition-all duration-300"
            >
              <span className={`text-sm font-bold w-6 text-center ${
                idx < 3 ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {idx + 4}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.rating}分</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}